import getHostName from 'helpers/getHostName';

export default function handleAuthorizeSource(
  query: {
    successRedirectUri: string;
    errorRedirectUri: string;
  },
  sourceId: string,
) {
  const q = `successRedirectUri=${encodeURIComponent(
    query.successRedirectUri,
  )}&errorRedirectUri=${encodeURIComponent(query.errorRedirectUri)}`;

  const subdomain = window.location.host.split('.')[0];
  // (note - pearl) For local cypress testing, update 'test-development' to 'test-cypress'
  const subdomainUrl = subdomain.includes('localhost') ? 'test-development' : subdomain;
  const hostName = getHostName();

  window.location.href = `https://${subdomainUrl}.${hostName}.com/api/sources/${sourceId}/authorize?${q}`;
}
